var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SummaryRow(props) {
    return (_jsxs("tr", { children: [_jsx("td", __assign({ className: "py-2 px-3 border md:w-1/3" }, { children: props.name }), void 0), _jsx("td", __assign({ className: "py-2 px-3 border" }, { children: props.children }), void 0)] }, void 0));
}
